module.exports = __webpack_public_path__ + "img/ASO_fr20.ed3ebc3b.png";